// extracted by mini-css-extract-plugin
export var menuIcon = "_u4-0";
export var menuIconInline = "_u4-1";